import type { ReportTheme } from '@/types/report';
import type { ThemeDefinition } from './types';

export type { ThemeVariables, ThemeDefinition } from './types';

import { formal } from './formal';
import { cleanMinimal } from './clean-minimal';
import { editorialWarm } from './editorial-warm';
import { modernDark } from './modern-dark';
import { newspaper } from './newspaper';
import { boldMagazine } from './bold-magazine';
import { academic } from './academic';
import { playful } from './playful';

export const THEMES: Record<ReportTheme, ThemeDefinition> = {
  formal,
  'clean-minimal': cleanMinimal,
  'editorial-warm': editorialWarm,
  'modern-dark': modernDark,
  newspaper,
  'bold-magazine': boldMagazine,
  academic,
  playful,
};

export function getTheme(name: ReportTheme): ThemeDefinition {
  return THEMES[name] ?? THEMES.formal;
}
